import getUserSettings from '../containers/with-user-settings/query.graphql'

const typeDefs = `
  type UserSettings {
    id: ID!
    browseStoresView: String!
  }

  type Mutation {
    updateUserSettings(userSettings: UserSettings!): UserSettings
  }
`

const UserSettings = {
  typeDefs,
  resolvers: {
    Mutation: {
      updateUserSettings: (_, { userSettings }, { cache }) => {
        cache.modify({
          id: cache.identify({
            __typename: 'UserSettings',
            id: 'UserSettings',
          }),
          fields: {
            browseStoresView(current) {
              return userSettings.browseStoresView ?? current?.browseStoresView
            },
          },
        })

        return cache.readQuery({
          query: getUserSettings,
        })
      },
    },
  },
  __typename: 'UserSettings',
  defaults: {
    browseStoresView: 'grid',
  },
}

export default UserSettings
